import React from 'react';

import GetJourneyStories from '@src/api/GetJourneyStories';
import { generateStory } from '@src/factories';
import useAxiosErrorHandler from '@src/hooks/useAxiosErrorHandler';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import useIsMounted from '@src/hooks/useIsMounted';
import { Story } from '@src/types';

const useJourneyStories = (id?: string) => {
  const axiosRequestConfig = useAxiosRequestConfig();
  const axiosErrorHandler = useAxiosErrorHandler();
  const [data, setData] = React.useState<Story[]>();
  const [loading, setLoading] = React.useState(true);
  const isMounted = useIsMounted();

  const makeRequest = React.useCallback(async () => {
    try {
      setLoading(true);
      let offset = 0;
      let fetch = true;
      let newData: Story[] = [];

      while (fetch) {
        const response = await GetJourneyStories(
          id,
          offset,
          20,
          axiosRequestConfig
        );
        if (response.data.journeyStoryList.length !== 0) {
          newData = newData.concat(
            response.data.journeyStoryList.map((story) => generateStory(story))
          );
          offset = offset + 20;
        } else {
          fetch = false;
        }
      }

      setData(newData);
      setLoading(false);
    } catch (e) {
      if (isMounted) {
        setLoading(false);
      }
      axiosErrorHandler(e);
    }
  }, [axiosErrorHandler, axiosRequestConfig, id, isMounted]);

  React.useEffect(() => {
    makeRequest().catch(console.log);
  }, [makeRequest]);

  return React.useMemo(() => ({ data, loading }), [data, loading]);
};

export default useJourneyStories;
